import(/* webpackMode: "eager" */ "/vercel/path0/src/app/industries/page.tsx");
